module.exports = __webpack_public_path__ + "img/Metastasis-NPC_GSE200310.f99a368c.png";